import { v4 as uuidv4 } from 'uuid'

/** Generates 36-character unique identifier */
export const generateUuid = () => uuidv4()
